import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import { IDefaultDevicesSettingsDTO } from '@/../client-generator/generated-clients/device-settings';

@Options({
  name: 'DeviceSettingsComponent',
  props: {
    defaultSettings: {
      type: Object as PropType<IDefaultDevicesSettingsDTO>,
      required: true,
    },
    deviceName: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:defaultSettings'],
})
export default class DeviceSettingsComponent extends Vue {
  defaultSettings!: IDefaultDevicesSettingsDTO;
  deviceName!: string;
  readonly!: boolean;
}
